import React from 'react';

import { Button, ButtonProps, Menu, MenuItemProps } from '@mantine/core';
import { CypressProps } from 'types';

interface MenuItem extends MenuItemProps, CypressProps {
  label: string | JSX.Element;
  onClick: () => void;
}

interface IButtonMenuProps extends ButtonProps {
  title: string;
  items: Array<MenuItem>;
}

const ButtonMenu = ({ title, items, ...buttonProps }: IButtonMenuProps): JSX.Element => {
  return (
    <Menu
      transitionProps={{
        transition: 'pop-top-right',
      }}
      withinPortal
    >
      <Menu.Target>
        <Button {...buttonProps}>{title}</Button>
      </Menu.Target>
      <Menu.Dropdown>
        {items.map(({ label, ...itemProps }, index) => (
          <Menu.Item key={index} {...itemProps}>
            {label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};
export default ButtonMenu;
